type NodeData = Record<string, unknown>;

/**
 * Merge a modify payload's node data onto an existing node's data without
 * letting a "no id" signal wipe a real id.
 */
export function mergeModifiedNodeData(
  existingData: NodeData,
  modifiedNodeData: NodeData,
): NodeData {
  const concreteEntries = Object.entries(modifiedNodeData).filter(
    ([, value]) => value !== null && value !== undefined,
  );

  return {
    ...existingData,
    ...Object.fromEntries(concreteEntries),
  };
}
